import { snakeCase } from 'lodash';
import { useLocalStorage } from './use-local-storage';

export enum PrereleaseFeature {
  ShiftStartDateInResourceManagement = 'ShiftStartDateInResourceManagement',
  ProjectToTemplates = 'ProjectToTemplates',
  DynamicSpaces = 'DynamicSpaces',
  DisableSocketUpdate = 'DisableSocketUpdate',
  SlackNotificationsConfig = 'SlackNotificationsConfig',
  PaginateAllTask = 'PaginateAllTask',
  InferredProgress = 'InferredProgress',
  Gpt = 'Gpt',
  TaskDependencyStatusFilter = 'taskDependencyStatusFilter',
  Variables = 'Variables',
}

export const allowed_hostnames = [
  'localhost',
  'northstar.nitro.run',
  'bangalore.nitro.run',
  'testing.nitro.run',
  'rmroles.orbits.run',
  'deepakkumar.nitro.run',
  'kei.orbits.run',
];

export const excluded_features_localhost = window.Cypress
  ? [PrereleaseFeature.PaginateAllTask]
  : [];

export const useFeature = (
  feature: PrereleaseFeature,
  offByDefault = false,
): boolean => {
  const [value] = useLocalStorage(
    `__features.v2.${snakeCase(feature)}`,
    !offByDefault && allowed_hostnames.includes(window.location.hostname),
  );

  // added for cypress - need to remove once the feature is live
  if (window.location.hostname.includes('localhost') && window.Cypress) {
    return !excluded_features_localhost.includes(feature);
  }

  return value;
};
